import { Button } from "@design";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/auth/AuthContext";
import { DevPersonaPicker } from "@/auth/dev/DevPersonaPicker";
import { CenteredScreen } from "@/components/CenteredScreen";
import { Text } from "@/components/Text";
import { getRuntimeConfig } from "@/config/runtime";
import { Logo } from "./Logo";

export function SignInScreen() {
  const { login } = useAuth();
  const { t } = useTranslation("shell");
  const isDevAuth = getRuntimeConfig().authProvider === "dev";
  return (
    <CenteredScreen>
      <Logo className="h-8" />
      {isDevAuth ? (
        <DevPersonaPicker />
      ) : (
        <>
          <Text tone="secondary">{t("signIn.prompt")}</Text>
          <Button variant="primary" onClick={() => login()}>
            {t("signIn.microsoft")}
          </Button>
        </>
      )}
    </CenteredScreen>
  );
}
